import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { sizes } from 'src/styles/Media.styled';
import HeaderTemplate from './HeaderTemplate';
import RowTemplateMobile from './RowTemplateMobile';
import RowTemplateDesktop from './RowTemplateDesktop';
import RowTemplateTab from './RowTemplateTab';
import { getPriceInNumberDataType } from 'src/pages/reportUsage/utils/dataModificaionUtil';
import { getTotalExtendedPrice } from 'src/pages/reportUsage/utils/eventHandlerUtil';
import { setPriceOverrideDetails } from 'src/pages/reportUsage/redux/action/actionCreators';

const PriceOverrideTable = ({
    priceOverrideTableData,
    setPriceOverrideTableData,
}) => {
    const dispatch = useDispatch();
    const priceOverRideDetails = useSelector(
        (state) => state.reportUsageRootReducer.priceOverRideDetails
    );
    const adjustedPriceChangeHandler = (e, item, index, qtyType) => {
        const updatedData = [...priceOverrideTableData];
        updatedData[index] = { ...item };
        const unitPrice = getPriceInNumberDataType(item.basePrice);
        const hasInvalidChars = /[^0-9.]/.test(e.target.value);
        const listPrice = item?.listPrice ? 
        parseFloat(item.listPrice) : 0;
        updatedData[index][
            qtyType === 'other'
                ? 'invalidOtherQtyAdjBasePriceMsg'
                : 'invalidUsedQtyAdjBasePriceMsg'
        ] =
            e.target.value &&
            (hasInvalidChars
                ? 'Invalid Adjusted Price'
                : e.target.value === '' || isNaN(e.target.value)
                ? 'Invalid Adjusted Price'
                : parseFloat(e.target.value).toFixed(2) === parseFloat(unitPrice).toFixed(2)
                ? 'Original price cannot be entered when requesting a price override. Please either adjust the price or leave the field blank.'
                : listPrice
                ? parseFloat(e.target.value) > listPrice &&
                  'Adjusted Price can\'t exceed List Price'
                : !listPrice && parseFloat(e.target.value) > unitPrice
                ? 'Adjusted Price can\'t be higher.'
                : null);
        updatedData[index][
            qtyType === 'other'
                ? 'adjustedOtherQtyPrice'
                : 'adjustedUsedQtyPrice'
        ] =
            e.target.value &&
            !updatedData[index][
                qtyType === 'other'
                    ? 'invalidOtherQtyAdjBasePriceMsg'
                    : 'invalidUsedQtyAdjBasePriceMsg'
            ]
                ? parseFloat(e.target.value).toFixed(2)
                : null;
        updatedData[index][
            qtyType === 'other'
                ? 'adjustedOtherQtyExtPrice'
                : 'adjustedUsedQtyExtPrice'
        ] = getTotalExtendedPrice(
            e.target.value &&
                !updatedData[index][
                    qtyType === 'other'
                        ? 'invalidOtherQtyAdjBasePriceMsg'
                        : 'invalidUsedQtyAdjBasePriceMsg'
                ]
                ? e.target.value
                : item.basePrice,
            item.lotSerial,
            qtyType
        );
        updatedData[index].adjustedExtPrice =
            updatedData[index].adjustedUsedQtyExtPrice &&
            updatedData[index].adjustedOtherQtyExtPrice
                ? getPriceInNumberDataType(
                      updatedData[index].adjustedUsedQtyExtPrice
                  ) +
                  getPriceInNumberDataType(
                      updatedData[index].adjustedOtherQtyExtPrice
                  )
                : updatedData[index].adjustedUsedQtyExtPrice &&
                  !updatedData[index].adjustedOtherQtyExtPrice
                ? getPriceInNumberDataType(
                      updatedData[index].adjustedUsedQtyExtPrice
                  ) +
                  getPriceInNumberDataType(updatedData[index].otherQtyExtPrice)
                : !updatedData[index].adjustedUsedQtyExtPrice &&
                  updatedData[index].adjustedOtherQtyExtPrice
                ? getPriceInNumberDataType(updatedData[index].usedQtyExtPrice) +
                  getPriceInNumberDataType(
                      updatedData[index].adjustedOtherQtyExtPrice
                  )
                : getPriceInNumberDataType(updatedData[index].usedQtyExtPrice) +
                  getPriceInNumberDataType(updatedData[index].otherQtyExtPrice);
        updatedData.priceOverriddenReason =
            priceOverRideDetails?.priceOverriddenReason;
        setPriceOverrideTableData(updatedData);
        dispatch(setPriceOverrideDetails(updatedData));
    };

    return (
        <React.Fragment>
            <HeaderTemplate />
            {priceOverrideTableData &&
                priceOverrideTableData.map((item, idx) =>
                    window.innerWidth < sizes.smalDevice ? (
                        <RowTemplateMobile
                            key={`${item.cfn} ${idx}`}
                            item={item}
                            adjustedPriceChangeHandler={
                                adjustedPriceChangeHandler
                            }
                            itemIdx={idx}
                        />
                    ) : window.innerWidth === sizes.smalDevice ? (
                        <RowTemplateTab
                            key={`${item.cfn} ${idx}`}
                            item={item}
                            adjustedPriceChangeHandler={
                                adjustedPriceChangeHandler
                            }
                            itemIdx={idx}
                        />
                    ) : (
                        <RowTemplateDesktop
                            key={`${item.cfn} ${idx}`}
                            item={item}
                            adjustedPriceChangeHandler={
                                adjustedPriceChangeHandler
                            }
                            itemIdx={idx}
                        />
                    )
                )}
        </React.Fragment>
    );
};

export default PriceOverrideTable;
